
import {__, propOr} from 'ramda';

const scales = ['small', 'medium', 'large'];

export const getSmallestUrlOfSize = (size, mediaJSON) =>
  scales.filter(scale => mediaJSON.renditions[scale + size])
    .reduce((prev, next) => prev || mediaJSON.renditions[next + size].url, null);

const icons = {
  video: 'play',
  image: 'image',
  audio: 'volume-off',
};

export const mediaIcon = propOr(icons.image, __, icons);
